const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/roles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/client/roles/")({
  beforeLoad: args => requirePermission(Permissions.ClientUsers.ManageRoles, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});